const API_URL = "https://ceo.iosx.in/";
export default API_URL;
